var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_24107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.847 274.124C228.964 284.052 191.411 284.774 174.025 282.608C152.496 279.925 65.2634 282.902 80.7373 275.238C80.7373 273.867 100.318 272.42 138.608 272.42C159.021 272.42 203.373 263.739 218.847 274.124Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.503 30.0874C152.408 46.7498 120.144 87.8572 58.0599 118.313C49.3538 122.584 40.2549 129.623 30.3488 133.242C33.7318 143.866 43.4927 162.647 48.6386 177.7C50.8708 176.317 59.6498 175.932 72.1736 170.876C96.7111 160.97 139.213 145.883 200.155 159.512C192.055 147.67 154.616 58.0223 161.503 30.0874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3488 133.242C18.8142 139.031 18.6682 149.417 23.8842 164.13C29.4212 179.749 41.3693 178.631 48.6386 177.7C43.4927 162.647 33.7318 143.866 30.3488 133.242Z",
    fill: "#FFD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3488 133.242C18.8142 139.031 18.6682 149.417 23.8842 164.13C29.4212 179.749 41.3693 178.631 48.6386 177.7M30.3488 133.242C33.7318 143.866 43.4927 162.647 48.6386 177.7M30.3488 133.242C40.2549 129.623 49.3538 122.584 58.0599 118.313C120.144 87.8572 152.408 46.7498 161.503 30.0874C154.616 58.0223 192.055 147.67 200.155 159.512C139.213 145.883 96.7111 160.97 72.1736 170.876C59.6498 175.932 50.8708 176.317 48.6386 177.7",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.441 88.232C210.595 106.528 214.7 124.251 215.944 137.837C216.567 144.632 216.471 150.373 215.568 154.626C214.662 158.896 212.966 161.571 210.472 162.41C207.967 163.252 204.754 162.214 201.089 159.478C197.439 156.753 193.413 152.396 189.323 146.77C181.146 135.521 172.746 119.248 166.596 100.962C160.443 82.6713 157.025 65.4003 156.466 52.2676C156.186 45.6992 156.623 40.1836 157.78 36.0987C158.94 32.0024 160.801 29.42 163.31 28.5759C165.82 27.7318 168.863 28.6646 172.263 31.2269C175.653 33.7822 179.335 37.9125 183.082 43.3146C190.574 54.1152 198.288 69.9412 204.441 88.232Z",
    fill: "#E6E6E6",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.011 94.8564C198.565 100.9 197.11 107.917 193.45 114.102C189.843 120.196 184.124 125.427 178.121 128.043C167.759 107.067 163.365 92.1803 161.099 82.0869C167.14 79.6162 174.538 79.7613 181.091 82.0312C187.727 84.3302 193.449 88.7924 196.011 94.8564Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2006 189.934L52.9002 173.588L90.3009 158.029L96.6387 160.523C96.8831 160.619 96.8289 160.98 96.567 161C96.2699 161.023 96.2593 161.455 96.555 161.492L101.016 162.054C101.414 162.104 101.688 162.474 101.608 162.867C101.262 164.575 100.286 168.856 98.8932 170.597C97.4101 172.451 94.7249 173.785 94.7249 173.785L110.643 219.054C113.741 218.302 116.903 220.032 117.939 223.047L118.151 223.664C118.981 226.076 118.41 228.749 116.667 230.612L111.737 235.883L94.1613 242.048C89.8412 243.564 85.1327 241.152 83.8391 236.76L70.6201 191.883L63.2006 189.934Z",
    fill: "#F0F0F0",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0845 189.892L60.7642 182.314L94.1696 180.142L107.147 225.116L107.295 225.106C109.901 224.937 112.298 226.533 113.147 229.002C114.214 232.103 112.495 235.47 109.358 236.425L94.226 241.033C90.0143 242.315 85.558 239.953 84.2545 235.748L70.6195 191.758L64.0845 189.892Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.184 147.745C105.865 148.677 106.915 149.27 108.065 149.372L150.752 153.126L119.346 156.14L100.897 160.187C98.8629 160.633 96.8264 159.444 96.2159 157.452L80.6373 106.635L88.4651 124.669C88.5824 124.94 88.7294 125.196 88.9032 125.434L105.184 147.745Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3089 117.092L75.4763 104C77.489 103.309 79.6695 104.447 80.2605 106.492C81.941 112.308 85.1968 123.309 88.349 132.467C91.5611 141.799 97.7727 154.14 101.093 160.49C102.157 162.527 101.169 165.046 99.0005 165.792L54.0168 181.267C52.1633 181.905 50.1341 180.987 49.3901 179.173L30.2807 132.6C27.725 126.371 30.9405 119.276 37.3089 117.092Z",
    fill: "#FCFCFC",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.327 100.554C242.848 95.8514 265.069 89.8313 277.781 103.371",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.135 81.6874C226.926 74.0544 244.751 57.8286 245.718 53.9894",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.983 85.193C240.086 83.1187 252.674 78.2685 254.194 75.4618",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7144 120.488L56.9955 112.495L42.1272 122.199C39.1255 124.159 37.5726 127.712 38.174 131.246L41.1851 148.94L33.4374 131.058C31.6611 126.959 33.5871 122.199 37.7144 120.488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_24107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeas);
export default __webpack_public_path__ + "static/media/ideas.3730360153a199dc5667f08beda4402a.svg";
export { ForwardRef as ReactComponent };